/* Remember the originating results, including a different category or search. */
(() => {
  const KEY = 'pidoof:shop-return';
  const catalogue = document.querySelector('[data-catalogue]');
  const remember = () => {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        url: window.location.pathname + window.location.search,
        label: catalogue.dataset.returnLabel,
      }));
    } catch {
      // The ordinary collection link remains usable without browser storage.
    }
  };

  if (catalogue) {
    remember();
    document.addEventListener('catalogue:updated', remember);
    window.addEventListener('popstate', remember);
    window.addEventListener('pageshow', remember);
    return;
  }

  const link = document.querySelector('[data-shop-return]');
  if (!link) return;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return;
    // Accept URLs saved by the previous theme version during this session.
    const saved = raw.startsWith('{') ? JSON.parse(raw) : { url: raw };
    if (typeof saved.url !== 'string') return;
    const target = new URL(saved.url, window.location.origin);
    const collections = (link.dataset.collectionsUrl || '/collections').replace(/\/$/, '');
    const search = link.dataset.searchUrl || '/search';
    const collectionHandle = target.pathname.startsWith(`${collections}/`)
      ? target.pathname.slice(collections.length + 1) : '';
    const allowed = target.pathname === search || (collectionHandle && !collectionHandle.includes('/'));
    // Restore only same-origin search/collection routes, never an arbitrary
    // stored URL. Paths supplied by Liquid preserve the active locale prefix.
    if (target.origin !== window.location.origin || !allowed) return;
    link.href = target.href;
    const label = link.querySelector('[data-shop-return-label]');
    if (label && typeof saved.label === 'string' && saved.label.trim()) label.textContent = saved.label;
  } catch {
    // Corrupt storage or a malformed URL must not break the native return link.
  }
})();
